/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"
// other
import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import CONSTANT from "../../constant"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"
import TenkoService from "../../service/truckcontrol/tenko/tenkoService"
import LocalAlertComponent from "../LocalAlertComponent"
import EmptyTextHeader from "../FlexGridWrapper/EmptyTextHeader"
import Spinner from "../Spinner"
import GridFooter from "../FlexGridWrapper/GridFooter"
import { TWijmoCellTemplateContext } from "../../type/wijmoComponents"
import { TTenkoSikkosyaGetRes } from "../../service/truckcontrol/tenko/TTenko"

/**
 * 点呼執行者検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */

const TenkoSikkosyaSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    setSikkosya: (value: TTenkoSikkosyaGetRes) => unknown
  }
> = (props) => {
  //#region [state]
  // Grid
  const [pageSize, setPageSize] = useState<number>(50)
  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })
  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  const search = async () => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    try {
      const res = await new TenkoService().getTenkoSikkosya()
      const newData = createCollectionView([...res.data], pageSize)
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
      flexGrid!.refresh()
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }

  const submitHandler = (item: TTenkoSikkosyaGetRes) => {
    props.setSikkosya(item)
    props.setIsShow(false)
  }
  //#endregion
  //#region [effect]
  useEffect(() => {
    if (flexGrid == null) return

    if (props.isShow) {
      search()
    }
  }, [props.isShow, flexGrid])
  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "運行管理者検索"}
      setIsShow={props.setIsShow}
      size={"lg"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* {アラート表示} */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col style={{ height: "35rem" }}>
              <wjrGrid.FlexGrid
                {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                keyActionTab={wjcGrid.KeyAction.None}
                selectionMode={wjcGrid.SelectionMode.Cell}
                style={{ height: "30rem" }}
                initialized={gridInitialized}>
                <wjrGridFilter.FlexGridFilter />
                <wjrGrid.FlexGridColumn
                  width={CONSTANT.GRID.COL_SIZE.COL_CODE_SIZE}
                  header="選択"
                  align={"center"}
                  binding="社員コード">
                  <EmptyTextHeader></EmptyTextHeader>
                  <wjrGrid.FlexGridCellTemplate
                    cellType={wjrGrid.CellTemplateType.Cell}
                    template={(
                      context: TWijmoCellTemplateContext<TTenkoSikkosyaGetRes>
                    ) => (
                      <Button onClick={() => submitHandler(context.item)}>
                        選択
                      </Button>
                    )}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={80}
                  header="社員CD"
                  binding="社員コード"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={100}
                  header="氏名"
                  binding="社員氏名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={80}
                  header="部所CD"
                  binding="部所コード"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={80}
                  header="部所名"
                  binding="部所略称"></wjrGrid.FlexGridColumn>
              </wjrGrid.FlexGrid>
              <GridFooter
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridData={gridData}
                isEnableExport={false}
                flexGrid={flexGrid}></GridFooter>
            </Col>
          </Row>
        </form>
      </Container>
    </ModalOuter>
  )
}
export default TenkoSikkosyaSearchModal
